import React from "react";
import { Dialog, Button, CircularProgress } from "@mui/material";
import { icon, IconComponent } from "../../../../common/components";
import styles from "./ConfirmationDialog.module.css";

export default function ConfirmationDialog({
	open,
	onClose,
	onConfirm,
	title,
	message,
	confirmLabel = "Confirmer",
	cancelLabel = "Annuler",
	iconType = icon.faExclamationTriangle,
	iconColor = "var(--red-500)",
	isLoading = false,
}) {
	const isProcessing = confirmLabel.includes("...");

	return (
		<Dialog
			open={open}
			PaperProps={{
				className: styles.dialogPaper,
			}}
			onClose={onClose}
		>
			<div className={styles.dialogContainer}>
				<div className={styles.leftSection}>
					<div className={styles.iconContainer}>
						<IconComponent color={iconColor} icon={iconType} size="5xl" />
					</div>
				</div>

				<div className={styles.rightSection}>
					<div className={styles.messageContainer}>
						{title && <div className={styles.title}>{title}</div>}

						{message && (
							<div className={styles.message}>
								{message.split("\n").map((line) => (
									<span key={line}>
										{line}
										<br />
									</span>
								))}
							</div>
						)}
					</div>

					<div className={styles.buttonContainer}>
						<Button
							className={styles.cancelButton}
							disabled={isProcessing || isLoading}
							variant="outlined"
							onClick={onClose}
						>
							{cancelLabel}
						</Button>
						<Button
							className={styles.confirmButton}
							disabled={isProcessing || isLoading}
							startIcon={
								isProcessing || isLoading ? (
									<CircularProgress size={20} sx={{ color: "white" }} />
								) : null
							}
							variant="contained"
							onClick={onConfirm}
						>
							{confirmLabel}
						</Button>
					</div>
				</div>
			</div>
		</Dialog>
	);
}
